import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute } from '@angular/router';
import { IdexService } from '../../idex.service';
import { LoadingButtonComponent } from '../../shared/loading-button/button';
import { InvoiceViewerComponent } from './invoice-viewer/invoice-viewer.component';

@Component({
   selector: 'app-etax-shared',
   templateUrl: './etax-shared.component.html',
   styleUrls: ['./etax-shared.component.scss']
})
export class EtaxSharedComponent {
   @HostBinding() className = 'app-etax-shared';
   @ViewChild('password') passwordInput!: ElementRef;
   loading = true;
   items: any[] = [];
   error = '';
   shared: any;
   password?: string;
   private shareId: string;

   constructor(activeRoute: ActivatedRoute, private service: IdexService, private dialog: MatDialog) {
      this.shareId = activeRoute.snapshot.paramMap.get('shareId');
      this.service.get(`etax/shared/${this.shareId}/info`).subscribe({
         next: shared => {
            this.shared = shared;
            if (shared.hasPassword) {
               this.loading = false;
               setTimeout(() => this.passwordInput.nativeElement.focus());
            } else {
               this.service.get(`etax/shared/${this.shareId}`).subscribe({
                  next: data => this.setData(data),
                  error: e => this.error = e.message
               }).add(() => this.loading = false);
            }
         },
         error: e => {
            this.error = e.message;
            this.loading = false;
         }
      });
   }

   checkPassword(password: string, button: LoadingButtonComponent): void {
      if (password.length) {
         button.busy();
         this.service.get(`etax/shared/${this.shareId}?pwd=${password}`).subscribe(data => {
            this.password = password;
            this.setData(data);
         }).add(() => button.reset());
      }
   }

   getThumnailUrl(item: any): string {
      return `${this.service.url}/etax/thumbnail/${item.id}`;
   }

   download(item: any): void {
      this.service.get(`etax/pdf/${item.id}`, { observe: 'response', responseType: 'arraybuffer' })
         .subscribe(resp => this.downloadBlob(item, resp));
   }

   downloadAll(): void {
      let url = `${this.service.url}/etax/download/${this.shareId}`;
      if (this.password) {
         url += `?pwd=${this.password}`;
      }
      window.open(url);
   }

   view(item: any): void {
      const url = `${this.service.url}/etax/pdf/${item.id}`;
      const enableBack = this.items.length > 1;
      const data = { url, logoUrl: this.shared.logoUrl, title: item.docNo, enableBack };
      const ref = this.dialog.open(InvoiceViewerComponent, { disableClose: true, data, panelClass: 'invoice-dialog' });
      ref.componentInstance.download.subscribe(() => this.download(item));
   }

   private setData(data: any) {
      this.items = data;
      if (data && data.length === 1) {
         this.view(data[0]);
      }
   }

   private downloadBlob(item: any, resp: HttpResponse<any>): void {
      let blobUrl = URL.createObjectURL(new Blob([resp.body], { type: 'application/pdf' }));
      const a = document.createElement('a');
      if (a.click) {
         a.href = blobUrl;
         a.target = '_parent';
         if ('download' in a) {
            a.download = `${item.name}`;
         }
         (document.body || document.documentElement).appendChild(a);
         a.click();
         if (a.parentNode) {
            a.parentNode.removeChild(a);
         }
         URL.revokeObjectURL(blobUrl);
      } else {
         if (window.top === window && blobUrl.split('#')[0] === window.location.href.split('#')[0]) {
            const padCharacter = blobUrl.indexOf('?') === -1 ? '?' : '&';
            blobUrl = blobUrl.replace(/#|$/, `${padCharacter}$&`);
         }
         window.open(blobUrl, '_parent');
      }
   }
}
